import React from 'react';
import {
  VStack, HStack, Text, Icon, Heading,
} from '@gluestack-ui/themed';
import { CheckCircle } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

import { GssPeopleSection } from './GssPeopleSection';

/**
 * EventSessionCompleted
 * -------------------
 * Completion confirmation plus optional GSS people section.
 */
const EventSessionCompleted = ({
  slotId,
  showPeopleSection = false,
}) => {
  const { t } = useTranslation();

  return (
    <VStack space="2xl">
      <VStack
        space="md"
        alignItems="center"
        justifyContent="center"
        py="$10"
        px="$6"
        bg="$bgSubtle"
        borderRadius="$lg"
        borderWidth={1}
        borderColor="$borderLight"
        testID="event-session-completed"
      >
        <HStack alignItems="center" space="sm" mb="$1">
          <Icon as={CheckCircle} size="2xl" color="$statusSuccess" />
          <Heading size="md" color="$textHeading">
            {t('student.eventTask.sessionCompletedTitle', 'Session Completed')}
          </Heading>
        </HStack>
        <Text size="sm" color="$textSubtle" textAlign="center" lineHeight="$sm">
          {t('student.eventTask.sessionCompletedMessage', 'You have attended this session.')}
        </Text>
      </VStack>

      {showPeopleSection && slotId ? (
        <GssPeopleSection slotId={slotId} />
      ) : null}
    </VStack>
  );
};

export default EventSessionCompleted;
